import type { AmountProps } from "./amountProps";
import type { ChangeEventHandler } from "react";

type Input = AmountProps;

export const useAmount = (input: Input) => {
  const { onAmountChange } = input;

  const handleAmountChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const numberValue = Number(event.target.value);
    if (!Number.isSafeInteger(numberValue)) return;
    onAmountChange(numberValue);
  };

  return { handleAmountChange };
};
